import React from 'react';

import styles from './Spacer.module.css';

const Spacer = () => <span className={styles.Spacer}> </span>;

export default Spacer;
